import React from 'react';
import { ArrowRight, Dumbbell, Flame, Trophy } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useTranslations } from '@/lib/translations';

export const CTASection = ({ onOpenChat }) => {
    const t = useTranslations();
    
    return (
        <section className="relative py-16 overflow-hidden">
            {/* Background */}
            <div className="absolute inset-0 bg-card" />
            <div className="absolute inset-0 noise-bg" />
            
            {/* Gradient overlay */}
            <div className="absolute inset-0 bg-gradient-to-b from-transparent via-primary/5 to-transparent" />

            <div className="container mx-auto px-4 relative z-10">
                <div className="max-w-3xl mx-auto text-center">
                    {/* Stats */}
                    <div className="flex flex-wrap justify-center gap-6 mb-10">
                        {[
                            { icon: Dumbbell, value: '500+', label: t.exercises },
                            { icon: Flame, value: '24/7', label: t.available },
                            { icon: Trophy, value: '∞', label: t.potential },
                        ].map((stat) => (
                            <div key={stat.label} className="flex flex-col items-center">
                                <div className="w-12 h-12 rounded-full gradient-gold flex items-center justify-center mb-2 shadow-gold">
                                    <stat.icon className="w-6 h-6 text-primary-foreground" />
                                </div>
                                <p className="font-display text-2xl text-foreground">{stat.value}</p>
                                <p className="text-sm text-foreground/70">{stat.label}</p>
                            </div>
                        ))}
                    </div>

                    {/* Main CTA */}
                    <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-wider mb-6 text-foreground">
                        {t.readyToTransform.split(' ').slice(0, -1).join(' ')} <span className="gradient-gold-text">{t.readyToTransform.split(' ').slice(-1)}</span>
                    </h2>
                    
                    <Button 
                        onClick={onOpenChat}
                        size="lg"
                        className="gradient-gold text-primary-foreground font-semibold text-base px-8 py-6 shadow-gold hover:opacity-90 transition-opacity group"
                    >
                        {t.startYourJourney}
                        <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
                    </Button>
                </div>
            </div>
        </section>
    );
};

export default CTASection;
